<template>
	<md-toolbar md-elevation="0" style="position: fixed; border-radius: 0px; padding: 0 0; background-color: #510093 !important;">
		<div class="md-toolbar-row">
			<div class="md-toolbar-section-start" style="justify-content:space-between">
				<h3 class="md-title" style="font-size: 15px;">{{$store.state.authentication.name}}</h3>
			</div>
			<div class="md-toolbar-section-end">

				<md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }"
					@click="toggleSidebar" style="color: #FFF !important">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button>

				<div class="md-collapse">

					<md-list>
						<md-list-item to="/">
							<i class="material-icons">dashboard</i>
							<p class="hidden-lg hidden-md">Dashboard</p>
						</md-list-item>

						<md-list-item to="/" class="dropdown">
							<drop-down>
								<a slot="title" class="dropdown-toggle" data-toggle="dropdown">
									<i class="material-icons">person</i>
									<!-- // <p class="">កៅ ចន្នដារ៉ា</p> -->

								</a>
								<ul class="dropdown-menu dropdown-menu-right">
									<li><a @click="logout()">ចាកចេញ</a></li>
								</ul>
							</drop-down>
						</md-list-item>
					</md-list>
				</div>
			</div>
		</div>

	</md-toolbar>
</template>

<script>
	export default {
		data() {
			return {
				printer: false,
				interval: null
			}
		},
		created() {
			// this.getPrinter();
		},
		beforeDestroy() {
			// clearInterval(this.interval);
		},
		methods: {
			getPrinter() {
				var self = this;
				this.interval = setInterval(() => {

					this.$http.get("https://localhost:8084/test").then(data => {
						self.printer = true;
					})
				}, 5000)
			},
			toggleSidebar() {
				this.$sidebar.showSidebar = !this.$sidebar.showSidebar
			},
			logout() {
				this.$store.state.authentication.loggedIn = false
				this.$store.state.authentication.authToken = null
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/TopNavbar.vue